define("shared/components/shared/profile-categorization/rewards-steps/provide-industry-report-data", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@ember/utils", "@glimmer/component", "ember-concurrency", "later/services/errors", "later/utils/number-helpers", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _utils, _component2, _emberConcurrency, _errors, _numberHelpers, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"ember-concurrency",0,"later/services/errors",0,"later/utils/number-helpers",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div {{did-update (perform this.getIndustryData) @socialProfile @averageProfileEngagement}}>
    {{yield this.yieldedHash}}
  </div>
  */
  {
    "id": "CXhSgP58",
    "block": "[[[11,0],[4,[38,0],[[28,[37,1],[[30,0,[\"getIndustryData\"]]],null],[30,1],[30,2]],null],[12],[1,\"\\n  \"],[18,3,[[30,0,[\"yieldedHash\"]]]],[1,\"\\n\"],[13]],[\"@socialProfile\",\"@averageProfileEngagement\",\"&default\"],false,[\"did-update\",\"perform\",\"yield\"]]",
    "moduleName": "shared/components/shared/profile-categorization/rewards-steps/provide-industry-report-data.hbs",
    "isStrictMode": false
  });
  let ProvideIndustryReportDataComponent = _exports.default = (_class = class ProvideIndustryReportDataComponent extends _component2.default {
    get socialProfile() {
      return this.args.socialProfile;
    }
    get followerCount() {
      return this.args.socialProfile.followedBy;
    }
    get industry() {
      return this.args.socialProfile.industry;
    }
    get allTasksAreLoading() {
      return this.categorizationRewards.getProfileIndustryComparison.isRunning;
    }
    get getIndustryResult() {
      return this.categorizationRewards.getProfileIndustryComparison.lastSuccessful?.value ?? undefined;
    }
    get industryHashtagsData() {
      return this.getIndustryResult?.topHashtags;
    }
    get isIndustryDataPresent() {
      return (0, _utils.isPresent)(this.getIndustryResult);
    }
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "errors", _descriptor, this);
      _initializerDefineProperty(this, "categorizationRewards", _descriptor2, this);
      _defineProperty(this, "numberStandardDeviations", 2);
      _defineProperty(this, "numberHashtags", 10);
      _defineProperty(this, "getIndustryData", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (!this.industry) {
            const error = new Error('Profile must have an industry to fetch reports.');
            this.errors.log(error, {}, _errors.ErrorSeverity.Info);
            return;
          }
          const fullIndustryData = yield this.getFullIndustryData.perform();
          if (!fullIndustryData) {
            return yield this.getPartialIndustryData.perform();
          }
          return fullIndustryData;
        }
      }), null, "getIndustryData", null));
      _defineProperty(this, "getPartialIndustryData", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          return yield this.categorizationRewards.getProfileIndustryComparison.linked().perform(this.socialProfile, this.industry);
        }
      }), {
        drop: true
      }, "getPartialIndustryData", null));
      _defineProperty(this, "getFullIndustryData", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (this.socialProfile.isBusiness || this.socialProfile.isCreator) {
            if (!this.args.averageProfileEngagement || !Number(this.args.averageProfileEngagement)) {
              return;
            }
            if (!this.followerCount) {
              const error = new Error('Profile must have more than 0 followers to fetch reports.');
              this.errors.log(error, {}, _errors.ErrorSeverity.Info);
              return;
            }
            return yield this.categorizationRewards.getProfileIndustryComparison.linked().perform(this.socialProfile, this.industry, this.followerCount, Number(this.args.averageProfileEngagement));
          }
          return;
        }
      }), {
        drop: true
      }, "getFullIndustryData", null));
      this.getIndustryData.perform();
    }

    // Note: template hash helper does not consistently trigger autotracking
    get yieldedHash() {
      return {
        isLoading: this.allTasksAreLoading,
        averageIndustryEngagement: this.averageIndustryEngagement,
        industryEngagementLimits: this.industryEngagementLimits,
        industryHashtags: this.industryHashtags,
        isIndustryDataPresent: this.isIndustryDataPresent
      };
    }
    get industryEngagementData() {
      if (!this.getIndustryResult || this.allTasksAreLoading) {
        return;
      }
      const {
        mean,
        sigmaPoints
      } = this.getIndustryResult;
      const sanitizedMean = mean ?? undefined;
      const minPoint = sigmaPoints.find(point => point[0] === -1 * this.numberStandardDeviations);
      const min = minPoint?.[1] ?? undefined;
      const maxPoint = sigmaPoints.find(point => point[0] === this.numberStandardDeviations);
      const max = maxPoint?.[1] ?? undefined;
      return {
        mean: sanitizedMean,
        limits: {
          min,
          max
        }
      };
    }
    get averageIndustryEngagement() {
      if (!this.industryEngagementData) {
        return;
      }
      const averageIndustryEngagement = (0, _numberHelpers.ratioToPercent)(this.industryEngagementData.mean);
      return (0, _numberHelpers.preciseRound)(averageIndustryEngagement, 2);
    }
    get industryEngagementLimits() {
      if (!this.industryEngagementData) {
        return;
      }
      const {
        limits
      } = this.industryEngagementData;
      return {
        min: (0, _numberHelpers.preciseRound)((0, _numberHelpers.ratioToPercent)(limits.min), 2),
        max: (0, _numberHelpers.preciseRound)((0, _numberHelpers.ratioToPercent)(limits.max), 2)
      };
    }
    get industryHashtags() {
      if (!this.industryHashtagsData || this.allTasksAreLoading) {
        return;
      }
      return this.industryHashtagsData.slice(0, this.numberHashtags).map(hashtag => `#${hashtag}`);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "categorizationRewards", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProvideIndustryReportDataComponent);
});